import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, Loader2, Sparkles } from "lucide-react";

export default function BillingSuccess() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Auto-redirect after 5 seconds
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          localStorage.setItem('startTutorialOnLoad', 'true');
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoToDashboard = () => {
    localStorage.setItem('startTutorialOnLoad', 'true');
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted/50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 relative">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-500/10">
              <CheckCircle className="h-8 w-8 text-green-500" />
            </div>
            <Sparkles className="absolute -top-1 -right-1 h-5 w-5 text-yellow-500 animate-pulse" />
          </div>
          <CardTitle className="text-2xl">Welcome to OptiBay!</CardTitle>
          <CardDescription>
            Your subscription is now active. You're all set to revolutionize your shop's scheduling.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="rounded-lg border bg-muted/50 p-4 text-center">
            <p className="text-sm text-muted-foreground mb-1">Your plan</p>
            <p className="text-lg font-semibold">Core Plan</p>
            <p className="text-xs text-muted-foreground mt-1">
              Full access to all core scheduling features
            </p>
          </div>

          <Button 
            className="w-full" 
            size="lg" 
            onClick={handleGoToDashboard}
          >
            Go to Dashboard
          </Button>

          <p className="text-center text-sm text-muted-foreground">
            Redirecting automatically in {countdown} seconds...
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
